module.exports = __webpack_public_path__ + "img/N375-1-EN.c9557942.png";